import React, { useState, useRef, useEffect } from 'react';

const SortDropdown = ({ currentSort, onSortChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const sortOptions = [
        { value: 'newest', label: 'Newest first', icon: 'fa-arrow-down-short-wide' },
        { value: 'oldest', label: 'Oldest first', icon: 'fa-arrow-up-wide-short' },
        { value: 'most_liked', label: 'Most liked', icon: 'fa-heart' },
        { value: 'most_active', label: 'Most active', icon: 'fa-comments' }
    ];

    const currentOption = sortOptions.find(option => option.value === currentSort) || sortOptions[0];

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSortSelect = (sortValue) => {
        if (sortValue !== currentSort) {
            onSortChange(sortValue);
        }
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative inline-block text-left" ref={dropdownRef}>
            <button
                onClick={toggleDropdown}
                type="button"
                className="flex items-center space-x-1 px-2 py-1.5 rounded-md transition-colors text-sm hover:bg-gray-weakest"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                <i className={`fa-solid ${currentOption.icon} mr-1.5`}></i>
                <span>{currentOption.label}</span>
                <i className={`fa-solid fa-chevron-${isOpen ? 'up' : 'down'} pl-2`}></i>
            </button>

            {isOpen && (
                <div className="origin-top-left absolute left-0 mt-1 w-56 rounded-md shadow-lg bg-gray-weak border border-gray-weakest focus:outline-none z-10">
                    <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="sort-menu">
                        {sortOptions.map((option) => (
                            <button
                                key={option.value}
                                onClick={() => handleSortSelect(option.value)}
                                className={`w-full text-left px-4 py-2 flex items-center hover:bg-gray-mid transition-colors
                                        ${currentSort === option.value
                                        ? 'bg-gray-strong text-gray-weak font-medium'
                                        : 'text-gray-more hover:text-gray-strong'}`}
                                role="menuitem"
                            >
                                <i className={`fa-solid ${option.icon} w-5`}></i>
                                <span className="ml-2">{option.label}</span>
                                {currentSort === option.value && (
                                    <i className="fa-solid fa-check ml-auto"></i>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SortDropdown;
